import addressInfoImageBlack from '../assets/addressinfo_two.png';
import arrowImage from '../assets/arrow.png';
import cardLineIcon from '../assets/card_line.png';
import closeIconBlack from '../assets/close_black.png';
import countryIcon from '../assets/country_icon.png';
import didiLogo from '../assets/didilogo.png';
import fifaLogo from '../assets/FIFA_logo.png';
import stepIconFour from '../assets/stepicon_four.png';
import stepIconOne from '../assets/stepicon_one.png';
import stepIconThree from '../assets/stepicon_three.png';
import stepIconTwo from '../assets/stepicon_two.png';

import {
    INPUT_CLOSE_ICON,
    INPUT_TIPS_ERROR_ICON,
    INPUT_TIPS_NORMAL_ICON
} from './loginImage';

export const DIDI_LOGO = didiLogo;
export const FIFA_LOGO = fifaLogo;
export const COUNTRY_ICON = countryIcon;
export const STAR_IMAGE =
    'https://s3-us01-public.didiglobal.com/ibg-fintech-marketing-team-v3/w2a-ui/star.png';
export const ARROW_IMAGE = arrowImage;
export const ADDRESS_INFO_LOGO = addressInfoImageBlack;
export const STEPICON_ONE = stepIconOne;
export const STEPICON_TWO = stepIconTwo;
export const STEPICON_THREE = stepIconThree;
export const STEPICON_FOUR = stepIconFour;
export const CLOSE_ICON = closeIconBlack;

export const BENEFIT_ONE =
    'https://s3-us01.didiglobal.com/ibg-fintech-marketing-team-v3/MSI-IMG/benefiticon_one.png';
export const BENEFIT_TWO =
    'https://s3-us01.didiglobal.com/ibg-fintech-marketing-team-v3/MSI-IMG/benefit_two_1.png';
export const BENEFIT_THREE =
    'https://s3-us01.didiglobal.com/ibg-fintech-marketing-team-v3/MSI-IMG/a_pizz.png';

/** 头图底图（无中间三行大标题），页面实际使用 */
export const FIFA_CARD_HEADER_BG =
    'https://s3-us01.didiglobal.com/ibg-fintech-marketing-team-v3/FIFA/FIFA_BG_CARD.png';

/** 目标效果参考稿（Card_1 完整渐变标题），页面不引用 */
export const FIFA_CARD_HEADER_EFFECT_REF =
    'https://s3-us01.didiglobal.com/ibg-fintech-marketing-team-v3/FIFA/FIFA_Card_1.png';

export const FIFA_BENEFIT_BG_1 =
    'https://s3-us01.didiglobal.com/ibg-fintech-marketing-team-v3/FIFA/FIFA_Benefit_1.png';
export const FIFA_BENEFIT_BG_2 =
    'https://s3-us01.didiglobal.com/ibg-fintech-marketing-team-v3/FIFA/FIFA_Benefit_2.png';
export const FIFA_BENEFIT_BG_3 =
    'https://s3-us01.didiglobal.com/ibg-fintech-marketing-team-v3/FIFA/FIFA_Benefit_3.png';

export const FIFA_BENEFIT_BGS = [
    FIFA_BENEFIT_BG_1,
    FIFA_BENEFIT_BG_2,
    FIFA_BENEFIT_BG_3
];

export const BG_ONE = FIFA_CARD_HEADER_BG;

/** introD 长页头图背景 */
export const BG_PAGED =
    'https://s3-us01.didiglobal.com/silver-bullet-img/2025-06-18/JS28X8/____2.png';

export const FIFA_BENEFIT_BG = {
    1: 'https://s3-us01.didiglobal.com/ibg-fintech-marketing-team-v3/FIFA/FIFA_Benefit_1.png',
    2: 'https://s3-us01.didiglobal.com/ibg-fintech-marketing-team-v3/FIFA/FIFA_Benefit_2.png',
    3: 'https://s3-us01.didiglobal.com/ibg-fintech-marketing-team-v3/FIFA/FIFA_Benefit_3.png'
} as const;

export type FifaBenefitBgType = keyof typeof FIFA_BENEFIT_BG;

/** FIFA END 页（card-end）专用资源 */
const FIFA_END_IMAGE_BASE =
    'https://s3-us01.didiglobal.com/ibg-fintech-marketing-team-v3/FIFA/END';

export const REGULAR_CARD_RETENTION = 'https://s3-us01.didiglobal.com/ibg-fintech-marketing-team-v3/FIFA/card_one_retention.png';
export const END_CARD_ADRESS = `${FIFA_END_IMAGE_BASE}/adress_card.png`;
export const END_CARD_PART_FOUR = `${FIFA_END_IMAGE_BASE}/card_part_4.png`;
export const END_CARD_PART_ONE = `${FIFA_END_IMAGE_BASE}/card_part_1.png`;
export const END_CARD_PART_THREE = `${FIFA_END_IMAGE_BASE}/card_part_3.png`;
export const END_CARD_PART_TWO = `${FIFA_END_IMAGE_BASE}/card_part_2.png`;
export const END_CARD_BENEFIT_ONE = `${FIFA_END_IMAGE_BASE}/card_1_benefit.png`;
export const END_CARD_BENEFIT_THREE = `${FIFA_END_IMAGE_BASE}/card_3_benefit.png`;
export const END_CARD_BENEFIT_TWO = `${FIFA_END_IMAGE_BASE}/card_2_benefit.png`;
export const END_CARD_BG_ONE = `${FIFA_END_IMAGE_BASE}/card_bg_one.jpg`;
export const END_CARD_BG_THREE = `${FIFA_END_IMAGE_BASE}/card_bg_three.jpg`;
export const END_CARD_BG_TWO = `${FIFA_END_IMAGE_BASE}/card_bg_two.jpg`;
export const END_CARD_BG_1 = `${FIFA_END_IMAGE_BASE}/card_bg_new_one.png`;
export const END_CARD_BG_2 = `${FIFA_END_IMAGE_BASE}/bg_two_card.png`;
export const END_CARD_CARD_BG = `${FIFA_END_IMAGE_BASE}/card_card_bg.jpg`;
export const END_CARD_LINE = cardLineIcon;
export const END_CARD_RETENTION = `${FIFA_END_IMAGE_BASE}/card_new_retention_bg.png`;
export const END_CARD_RETENTION_TITLE =
    '¡Aprovéchalo ya! ¡Tu cupón está listo！';
export const END_CARD_RETENTION_TEXT =
    'Divide tus compras a 3 Meses Sin Intereses sin importar el monto o el comercio.';
export const END_CARD_RETENTION_CONFIRM = 'Úsalo ahora';
export const END_CARD_RETENTION_CONFIRM_COLOR =
    'linear-gradient(#FF5F14,#FF5F14)';
export const END_CARD_TEXT_ONE = `${FIFA_END_IMAGE_BASE}/card_new_benefit_1.png`;
export const END_CARD_TEXT_THREE = `${FIFA_END_IMAGE_BASE}/card_new_benefit_2.png`;
export const END_CARD_TEXT_TWO = `${FIFA_END_IMAGE_BASE}/card_new_benefit_3.png`;
export const END_CARD_TITLE_BG = `${FIFA_END_IMAGE_BASE}/card_title_bg.jpg`;
export const END_FOOT_LOGO_DOWNLOAD = `${FIFA_END_IMAGE_BASE}/foot_logo_download.jpg`;

/** card-end 页预加载分组标识 */
export const CARD_END_PAGE_TYPE = 'card_end';

/** card-end 首屏：顶栏、头图、登录卡片 */
export const FIRST_SCREEN_IMAGES_CARD_END: string[] = [
    END_FOOT_LOGO_DOWNLOAD,
    CLOSE_ICON,
    STAR_IMAGE,
    END_CARD_BG_1,
    END_CARD_TEXT_ONE,
    END_CARD_CARD_BG,
    END_CARD_LINE,
    COUNTRY_ICON,
    INPUT_CLOSE_ICON,
    INPUT_TIPS_NORMAL_ICON,
    INPUT_TIPS_ERROR_ICON
];

/** card-end 非首屏：第二背景、权益、步骤、地址等 */
export const REMAINING_IMAGES_CARD_END: string[] = [
    END_CARD_BG_2,
    END_CARD_TEXT_TWO,
    END_CARD_BENEFIT_ONE,
    END_CARD_BENEFIT_TWO,
    END_CARD_BENEFIT_THREE,
    END_CARD_TEXT_THREE,
    END_CARD_PART_ONE,
    END_CARD_PART_TWO,
    END_CARD_PART_THREE,
    END_CARD_PART_FOUR,
    END_CARD_ADRESS,
    END_CARD_RETENTION
];
